import React from 'react'
import { useForm, useFieldArray } from 'react-hook-form';
import APIS from '../../../constant/EndPoint';
import Button from '../../Reusable/Button';
import ComboboxInput from '../../Reusable/Form/ComboboxInput';

const Transit = (props: any) => {
  const {
    register,
    control,
    handleSubmit,
    setError,
    setValue,
    watch,
    getValues,
    clearErrors,
    formState: { errors },
  } = useForm({
    defaultValues: {
      transit: [
        {
          branch: "",
        },
      ],
    },
    mode: "onBlur",
  });
  const { fields, append, remove } = useFieldArray({
    name: "transit",
    control,
  });
  return (
    <>
      {fields.map((field, index) => {
        return (
          <React.Fragment key={field.id}>
            <div className="w-full flex justify-left gap-x-2 mt-6 uppercase font-extrabold items-center">
              <span className="text-[#5E5757] font-bold text-sm">
                Transit No. {index + 1}
              </span>
            </div>
            <div className="w-full grid grid-cols-2 mb-8">
              <ComboboxInput
                url={APIS.BRANCH}
                queryKey={"branch"}
                register={register(`transit.${index}.branch` as const, {
                  required: "Branch is required",
                })}
                errors={errors?.transit?.[index]?.branch}
                name={`transit.${index}.branch`}
                label={""}
                setValue={setValue}
                placeholder={"Search Branch"}
                getValues={getValues}
                clearErrors={clearErrors}
              />
              <div className='w-full flex justify-end items-center'>
              <div className="w-[150px] text-right">
                <Button
                  label={"Remove"}
                  disabled={index === 0 ? true : false}
                  onClick={() => remove(index)}
                />
              </div>
              </div>
              
            </div>

          </React.Fragment>
        );
      })}
      <div className="flex justify-end w-full">
        <div className="w-[100px] mr-4">
          <Button
            label={"Add New"}
            onClick={() =>
              append({
                branch: "",

              })
            }
          />
        </div>
        <div className="w-[100px] mr-4">
          <Button
            label={"Submit"}
            onClick={handleSubmit((data: any) =>
              props?.handleActionMenu(data, "Transit", setError)
            )}
          />
        </div>
      </div>
    </>
  )
}

export default Transit
